import React, { useContext, useState } from 'react';

import { Popover } from 'antd';

import styled from 'styled-components';

import { ListContext } from '@contexts/ListContext';

import EventDateModelOptionNumbers from './EventDateModelOptionNumbers';

const OptionNumberStyled = styled.div`
    background-color: #${(props) => props.$bgcolor};
    color: #${(props) => props.$fgcolor};
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 0.95rem;
    cursor: ${(props) => (props.$readonly ? 'default' : 'pointer')};

    small {
        font-size: 0.65rem;
    }
`;

const OptionNumber = ({
    number,
    event,
    selectedModel,
    readOnly,
    reloadGroupedModels,
    eventDateInfo,
    eventDatesModel,
    onExtendOptionNumberToAllDates,
    onChangeOptionNumber,
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const { cachedList } = useContext(ListContext);

    if (event.TypeName === 'Casting') {
        return null;
    }

    let eventStyle = null;
    const evtypevalue = event.TypeName ? event.TypeName.toLowerCase() : event.Type ? event.Type.toLowerCase() : null;
    const evtypeid = evtypevalue ? (evtypevalue === 'job' ? 20 : evtypevalue === 'ext' ? 30 : 20) : 20;
    const parentEvent = cachedList.eventTypes.items.find((et) => et.id === evtypeid);
    if (event && event.SubTypeCode) {
        eventStyle = parentEvent.subTypes.find((st) => st.Code === event.SubTypeCode);
    } else {
        eventStyle = parentEvent.subTypes.find((st) => st.Default);
    }
    const projectID = event ? (event.ProjectID ? event.ProjectID : event.Project ? event.Project.ID : null) : null;

    const getColors = () => {
        let bgcolor = 'f5222d';
        let fgcolor = 'ffffff';
        if (number === 10) {
            if (eventStyle.BackColor) {
                bgcolor = eventStyle.BackColor;
            }
            if (eventStyle.ForeColor) {
                fgcolor = eventStyle.ForeColor;
            }
            return { bgcolor, fgcolor };
        } else {
            if (number === 1 && eventStyle.FirstOptionBackColor) {
                bgcolor = eventStyle.FirstOptionBackColor;
                fgcolor = eventStyle.FirstOptionForeColor;
                return { bgcolor, fgcolor };
            }
            if (number === 2 && eventStyle.SecondOptionBackColor) {
                bgcolor = eventStyle.SecondOptionBackColor;
                fgcolor = eventStyle.SecondOptionForeColor;
                return { bgcolor, fgcolor };
            }
            if (number === 3 && eventStyle.ThirdOptionBackColor) {
                bgcolor = eventStyle.ThirdOptionBackColor;
                fgcolor = eventStyle.ThirdOptionForeColor;
                return { bgcolor, fgcolor };
            }
            if (eventStyle.OptionBackColor) {
                bgcolor = eventStyle.OptionBackColor;
                fgcolor = eventStyle.OptionForeColor;
                return { bgcolor, fgcolor };
            }
            bgcolor = 'fadb14';
            fgcolor = '000000';
            return { bgcolor, fgcolor };
        }
    };

    const { bgcolor, fgcolor } = getColors();

    const afterUpdate = (model) => {
        if (reloadGroupedModels) {
            reloadGroupedModels(model);
        }
        if (onChangeOptionNumber) {
            onChangeOptionNumber();
        }
        setIsVisible(false);
    };

    const handleExtendOptionNumberToAllDates = (modelId, optionNumber) => {
        onExtendOptionNumberToAllDates(modelId, optionNumber);
        setIsVisible(false);
    };

    if (readOnly) {
        return (
            <OptionNumberStyled $isConfirmed={number === 10} $bgcolor={bgcolor} $fgcolor={fgcolor} $readonly>
                {number === 10 ? <small>JOB</small> : number}
            </OptionNumberStyled>
        );
    }

    return (
        <Popover
            placement="bottom"
            title="CHANGE OPTION NUMBER"
            trigger="click"
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            open={isVisible}
            onOpenChange={(visible) => setIsVisible(visible)}
            content={
                <EventDateModelOptionNumbers
                    eventID={event.ID}
                    projectID={projectID}
                    selectedModel={selectedModel}
                    eventDates={event.EventDates}
                    eventDateInfo={eventDateInfo}
                    eventDatesModel={eventDatesModel}
                    onExtendOptionNumberToAllDates={handleExtendOptionNumberToAllDates}
                    afterUpdate={afterUpdate}
                    showEvents
                />
            }
        >
            <OptionNumberStyled $isConfirmed={number === 10} $bgcolor={bgcolor} $fgcolor={fgcolor}>
                {number === 10 ? <small>JOB</small> : number}
            </OptionNumberStyled>
        </Popover>
    );
};

export default OptionNumber;
